"use client"

import { Fragment } from 'react'
import { useStoreData } from "@/hooks/store/useStoreData"
import { Col, Row } from "antd"

const DescriptionCategory = ({ categoryDetail }: { categoryDetail: any }) => {
  const { store } = useStoreData()
  const meta = categoryDetail.meta

  const config = meta.description?.use_default ? store.home_description : meta.description

  if (!config?.content || config?.content === '<p></p>') {
    return <Fragment />
  }

  return (
    <Col span={24}>
      <Row
        justify="center"
        style={{
          paddingInline: "1rem",
          ...(config?.bg_image ? {
            backgroundImage: `url("${config?.bg_image}")`,
            backgroundRepeat: config?.bg_mode === 'fill' ? 'no-repeat' : 'repeat',
            backgroundSize: config?.bg_mode === 'fill' ? 'cover' : `${config?.bg_width}px ${config?.bg_height}px`,
            backgroundPosition: 'center'
          } : {}),
          backgroundColor: config?.bg_color,
          color: config?.color
        }}

      >
        <Col style={{ paddingInline: 0 }} className="page__section ql-editor" dangerouslySetInnerHTML={{ __html: config?.content || '' }} />
      </Row>
    </Col>
  )
}

export default DescriptionCategory